import React, { useEffect, useCallback, useState } from 'react';
import { Link } from 'js/components/common/Link';
import { openNewWindow, openWindow } from 'js/utils/url.util';
import { useGetURLTemplates } from 'js/hooks/useGetURLTemplates';
import { componentService } from 'js/services/component.service';

import * as helpers from './helpers';
import { useFormatterParams } from './hooks';

export const UrlTemplateLink = ({
    name,
    target,
    children,
    ...props
}) => {
    const [url, setUrl] = useState();
    const getUrlTemplates = useGetURLTemplates();
    const formatterParams = useFormatterParams();

    const onClick = useCallback(event => {
        event.preventDefault();

        if (!url) {
            return;
        }

        target === 'window'
            ? openNewWindow(url)
            : openWindow(url, target || '_self');
    }, [target, url]);

    useEffect(() => {
        (async function() {
            const response = await getUrlTemplates({ urlTypeList: [name] });
            const urlTemplates = response?.data?.urlList || [];

            if (!urlTemplates.length) {
                return;
            }

            setUrl(helpers.formatURL(urlTemplates[0].url, formatterParams));
        })();
    }, [name, formatterParams, setUrl, getUrlTemplates]);

    return <Link href="#" onClick={onClick} {...props}>{children}</Link>;
};

componentService.registerWebContentComponents({ UrlTemplateLink });
